<template>
  <div v-if="!loading">
    <h1 class="main-header">
      <translate translate-context="roles" :translate-params="{id: role.id, name: role.name}">Edit Role  #%{id} - %{name}</translate>
    </h1>
    
    <CCard>
      <CCardHeader>
        <div class="card-header-actions">
          <CButton variant="outline" color="success" @click="onReset" class="mr-2" v-translate translate-context="form">Reset</CButton>
          <CButton color="primary" @click="onClickSave" v-translate translate-context="form">Save</CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <Form ref="role_form" :data="role" @save="onSave" :save_text="$pgettext('form','Save')" edit/>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {RecordNotFound, SuccessNotification} from "@/domain/core/exception/exceptions";
import Form from "@/domain/roles/components/Form.vue";

export default {
  name: 'EditRole',
  components: {Form},
  data() {
    return {
      loading: true,
    }
  },
  async mounted() {
    try {
      await this.fetchRole(this.$route.params.id)
    } catch (e) {
      if (e instanceof RecordNotFound) {
        await this.$router.push({name: 'roles.list'})
      }
    }
    this.loading = false
  },
  computed: {
    ...mapGetters('roles', [
      'role',
    ]),
  },
  methods: {
    ...mapActions('roles', [
      'fetchRole',
      'updateRole',
    ]),
    async onSave(data) {
      await this.updateRole({id: this.role.id,data: data})
      await this.$router.push({name: 'roles.list'})
      throw new SuccessNotification(this.$pgettext('roles', 'Role updated!'))
    },
    onClickSave() {
      this.$refs.role_form.onSave()
    },
    onReset() {
      this.$refs.role_form.onReset()
    }
  }
}
</script>

<style scoped>

</style>